import script from "./3.CurrentlyUseAccutaneAndOthers.vue?vue&type=script&setup=true&lang=ts"
export * from "./3.CurrentlyUseAccutaneAndOthers.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__